import { render, staticRenderFns } from "./Otherprocurementedit.vue?vue&type=template&id=4831b9a0&scoped=true"
import script from "./Otherprocurementedit.vue?vue&type=script&lang=js"
export * from "./Otherprocurementedit.vue?vue&type=script&lang=js"
import style0 from "./Otherprocurementedit.vue?vue&type=style&index=0&id=4831b9a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4831b9a0",
  null
  
)

export default component.exports